/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CustomerType {
    PrivateCustomer = 'PrivateCustomer',
    CompanyCustomer = 'CompanyCustomer'
  }

    export const CustomerTypeTranslocoMap: Record<CustomerType, string> = {
    [CustomerType.PrivateCustomer]: 'customerType.privateCustomer',
    [CustomerType.CompanyCustomer]: 'customerType.companyCustomer',
    };

    export const CustomerTypeOptions = [
  { value: CustomerType.PrivateCustomer, labelKey: 'customerType.privateCustomer' },
  { value: CustomerType.CompanyCustomer, labelKey: 'customerType.companyCustomer' },
    ];

